import Modal from 'react-modal';
import Button from '../../../../GlobalComponents/Button';
import Input from '../../../../GlobalComponents/Input';
import ModalHeader from '../../../../GlobalComponents/Modal/ModalHeader';
import { useTranslation } from 'react-i18next';
import UseAddEditCoverTitle from '../../Library/CoverTitles/UseAddEditCoverTitle';
import UseGetCoverTitle from '../../Library/CoverTitles/UseGetCoverTitle';
import Loading from '../../../../GlobalComponents/Loading';
import Error from '../../../../GlobalComponents/Error';
import { GetApolloErrorText } from '../../../../GlobalFunctions/helper';
import { UseAuth } from '../../../Auth/Library/UseAuth';

Modal.setAppElement('#root');

const AddEditCoverTitle = ({selectedCoverTitleID,SetSelectedCoverTitleID,OnAddEditSuccess}) => {

    const {user} = UseAuth();
    const {t} = useTranslation();
    const {
        loading,
        error,
        formData,
        AddEditCoverTitle,
        InitFormData,
        SetFormData,
        SetFormLangData,
        GetFormLangValue,
    } = UseAddEditCoverTitle(selectedCoverTitleID,user.lang,(d) => OnAddEditSuccess(d));

    const {
        allLanguageMutations, 
        loading:getLoading,
        error:getError
    } = UseGetCoverTitle(selectedCoverTitleID,user.lang,(d) => {
        InitFormData(d)
    });

    var err = "";
    if(error || getError)
        err = GetApolloErrorText(error || getError)

    return(
        <Modal
            isOpen={true}
            onRequestClose={() => SetSelectedCoverTitleID(null)}
            overlayClassName={"modal-overlay"}
            className={"modal-content"}
        >
            <ModalHeader 
                title = {(selectedCoverTitleID === 0 ? t("AddCoverTitle") : t("EditCoverTitle"))}
                allLanguages = {allLanguageMutations}
                OnClose ={() => SetSelectedCoverTitleID(null)}
                selectedLang = {formData.selectedLang}
                OnLangSelect = {(e) => SetFormData(e)}
            />

            <div className="modal-body">

                {err ?
                    <Error className="no-margin" text={err} />
                :
                    <>
                        {loading || getLoading ?
                            <Loading />
                        : 
                            <>
                                
                                <div className="row">
                                    <div className={"col-50"}>
                                                
                                        <div className="form-group">
                                            <label>*{t("CoverTitleName")} ({formData.selectedLang})</label>
                                            <Input
                                                name="name"
                                                value={GetFormLangValue("name")}
                                                OnChange={(e) => SetFormLangData(e)}
                                            />
                                        </div>
                                    </div>
                                                                        
                                    <div className="col-50">
                                        <div className="form-group">
                                            <label>*{t("Shortcut")}</label>
                                            <Input
                                                name="shortcut"
                                                value={formData.shortcut}
                                                OnChange={(e) => SetFormData(e)}
                                            />
                                        </div>
                                    </div>
                                </div> 
                            </>
                        }
                    </>
                }
            </div>
            <div className="modal-footer">
                <Button
                    className={"btn-primary w-100"}
                    OnClick={() => AddEditCoverTitle()}
                >
                    {(selectedCoverTitleID === 0 ? t("Add") : t("Edit"))}
                </Button>
            </div>

        </Modal>
    )
}

export default AddEditCoverTitle;